import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
	async deleteNote(accessToken,  note_id) {
        let res = await axios.delete(API_NAME + "/notes/" + note_id ,
            {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
            
          });
          
        return res.data;
      },
      async saveNote(accessToken,  formdata) {
        let res = await axios.post(API_NAME + "/notes" ,  formdata,
            {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
            
          });
          
        return res.data;
      },
      async markNoteAsRead(accessToken,  note_id) {
        let res = await axios.post(API_NAME + "/notes/" + note_id + "/mark_read" ,  {},
            {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          });
          return res.data;
      },
  
  
}